zpr-dropdown {
  display: none;
  box-shadow: 0 2px 4px 0 rgba(52, 75, 96, 0.1), 0 1px 3px 0 rgba(52, 75, 96, 0.2);
  background-color: white;
  border-radius: 8px;
  min-width: 200px;
  width: max-content;
  border: 0 none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 255;
  box-sizing: border-box;
  overflow-y: auto;

  &.open {
    display: block;
  }

  &[size="large"] {
    width: 268px;
  }

  > [slot="body"] > main {
    overflow-y: auto;
  }
}
